/**
 * LOCAL STORE VISITS objective — Performance Max with store goals (linked
 * Business Profile locations). Pages: LocalPage, LocalCampaignWizard,
 * CreateLocalAssetGroup. Shares the Performance Max build path with Sales.
 */
import { MapPin } from 'lucide-react';
import { PmaxObjectiveConfig } from '@/components/google-ads/performance-max/pmaxShared';

export const LOCAL_BASE = '/google-ads/local';

export const LOCAL_OBJECTIVE: PmaxObjectiveConfig = {
  key: 'local',
  title: 'Local store visits',
  base: LOCAL_BASE,
  subtitle: 'Performance Max with store goals — drive visits, calls and directions to your locations',
  icon: MapPin,
  storeGoals: true,
  goal: 'Store visits and local actions',
  namePrefix: 'PMax - Local',
  emptyHint: 'Bring people to your shop, restaurant or showroom. Link your Google Business Profile, add your images and text, and Google promotes your locations on Maps, Search, YouTube and Display.',
};
